const _excluded = ["indeterminate", "className", "id", "disabled"];function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function _objectWithoutProperties(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function _objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;} /* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-multi-comp */
import React, { useEffect, useRef } from 'react';








import { ChevronUpDownIcon, ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/20/solid';
import { t } from "../../../../I18N";

















const IndeterminateCheckbox = (_ref) =>





{let { indeterminate, className = '', id, disabled } = _ref,rest = _objectWithoutProperties(_ref, _excluded);
  const ref = useRef(null);

  useEffect(() => {
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate, rest.checked]);

  return /*#__PURE__*/ (
    // eslint-disable-next-line react/jsx-props-no-spreading

    _jsx("label", {}, void 0, /*#__PURE__*/
    _jsx("span", { className: "sr-only" }, void 0,
    id === 'checkbox-header' ?
    t('System', 'Select all', null, false) :
    t('System', 'Select', null, false)
    ), /*#__PURE__*/
    React.createElement("input", _extends({
      type: "checkbox",
      ref: ref,
      className: `rounded cursor-pointer ${className} ${disabled ? 'opacity-50' : ''}`,
      disabled: disabled },
    rest)
    )
    ));

};

// eslint-disable-next-line comma-spacing
const getIcon = (header, sortedChanged) => {
  const sorting = !sortedChanged ? header.column.getIsSorted() : false;
  const testId = `${header.id}_${sorting.toString()}`;
  switch (sorting) {
    case false:
      return /*#__PURE__*/_jsx(ChevronUpDownIcon, { "data-testid": testId, className: "w-4" });
    case 'asc':
      return /*#__PURE__*/_jsx(ChevronUpIcon, { "data-testid": testId, className: "w-4" });
    case 'desc':
    default:
      return /*#__PURE__*/_jsx(ChevronDownIcon, { "data-testid": testId, className: "w-4" });
  }
};

// eslint-disable-next-line comma-spacing
const CheckBoxHeader = ({ table }) => /*#__PURE__*/
React.createElement(IndeterminateCheckbox, {

  checked: table.getIsAllRowsSelected(),
  indeterminate: table.getIsSomeRowsSelected(),
  onChange: table.getToggleAllRowsSelectedHandler(),
  id: 'checkbox-header' }

);


// eslint-disable-next-line comma-spacing
const CheckBoxCell = ({ row }) => /*#__PURE__*/
React.createElement(IndeterminateCheckbox, {

  checked: row.getCanExpand() ?
  row.getIsAllSubRowsSelected() && row.getIsSelected() :
  row.getIsSelected(),
  disabled: !row.getCanSelect(),
  indeterminate: row.getIsSomeSelected() || row.getIsAllSubRowsSelected(),
  onChange: (e) => {
    row.getToggleSelectedHandler()(e);
    row.subRows.forEach((subRow) => subRow.getToggleSelectedHandler()(e));
  },
  id: row.id }

);



export { CheckBoxHeader, CheckBoxCell, getIcon };